import { Facebook, Instagram, Twitter, Youtube, Music2, Link as LinkIcon } from "lucide-react";

/**
 * Read-only inline display of social links as icon buttons.
 * `socials` = { facebook, instagram, x, youtube, tiktok, other } — empty keys skipped.
 */
export default function SocialsDisplay({ socials, testIdPrefix = "socials-display" }) {
    if (!socials) return null;
    const items = [
        { key: "facebook", icon: Facebook, label: "Facebook" },
        { key: "instagram", icon: Instagram, label: "Instagram" },
        { key: "x", icon: Twitter, label: "X" },
        { key: "youtube", icon: Youtube, label: "YouTube" },
        { key: "tiktok", icon: Music2, label: "TikTok" },
        { key: "other", icon: LinkIcon, label: "Other" },
    ].filter((r) => socials[r.key] && socials[r.key].trim());

    if (items.length === 0) return null;

    return (
        <div className="flex flex-wrap items-center gap-2" data-testid={testIdPrefix}>
            {items.map(({ key, icon: Icon, label }) => (
                <a
                    key={key}
                    href={ensureUrl(socials[key])}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${testIdPrefix}-${key}`}
                    title={label}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-[#2a2a2a] bg-[#141414] hover:border-[#ff4500] hover:text-[#ff4500] transition-colors text-xs uppercase tracking-wider text-[#cfcfcf]"
                >
                    <Icon className="h-3.5 w-3.5" />
                    {label}
                </a>
            ))}
        </div>
    );
}

function ensureUrl(u) {
    if (!u) return "#";
    const t = u.trim();
    if (/^https?:\/\//i.test(t)) return t;
    return `https://${t}`;
}
